import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Template } from '../../modules/scheduling/models/company.model';
import { AuthService } from '../../core/services/auth.service';
import { EventService } from '../../shared/services/event.service';

@Component({
  selector: 'fz-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit, OnDestroy {
  /** Última URL interna anterior (NavigationEnd), para back-safe. */
  private prevInternalUrl: string | null = null;
  private currentInternalUrl: string | null = null;
  private navSub?: Subscription;
  isMenuExpanded: boolean;
  logoFilazero = 'assets/images/logo/fz-logo-white.svg';
  logoRoute = '/home';
  template = new Template();
  user = undefined;
  displayBackButton: boolean;

  constructor(
    private readonly _auth: AuthService,
    private readonly _router: Router,
  ) {

    this.navSub = this._router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.prevInternalUrl = this.currentInternalUrl;
        this.currentInternalUrl = e.urlAfterRedirects;
      }
    });
    this.getUserInfo();

    if (!this.user) {
      this.user = undefined;
    }

    this.isMenuExpanded = false;

    EventService.changeTemplate.subscribe((template: Template) => {
      this.template = template;
    });

    EventService.changeLogoRoute.subscribe((response) => {
      this.logoRoute = response;
    });

    EventService.afterLogin.subscribe(() => this.getUserInfo());

    EventService.changeButtonBack.subscribe((response) => this.displayBackButton = response );
  }

  ngOnInit() {
    this.getUserInfo();
  }

  menuReduce(): void {
    this.isMenuExpanded = false;
  }

  menuToggle(): void {
    this.isMenuExpanded = !this.isMenuExpanded;
  }

  isAuth(): boolean {
    return this._auth.isAuth();
  }

  getUserInfo() {
    const userData = JSON.parse(localStorage.getItem('authorizationData'));

    if (userData) {
      this.user = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.userName
      };
    }
  }

  logOut(): void {
    this.user = undefined;
    this._auth.logOut();
    this.menuReduce();
    this._router.navigate(['/user/login']);
  }


  backRoute() {
    // Volta para a última rota interna; history.back() puro sai do site em deep-link.
    void this._router.navigateByUrl(this.prevInternalUrl ?? '/home');
  }

  ngOnDestroy(): void {
    this.navSub?.unsubscribe();
  }

}
